module.exports = __webpack_public_path__ + "img/General.f03f0037.svg";